<template>
  <div class="dashboard-panel">
    <div style="padding: 10px;">
      <div class="bg-primary textColor" style="margin-top: 10px; padding: 20px; text-align: center;"
          v-if="!user.subscription">
            <h3>{{ $t("dashboard.atention") }}</h3>
            <h4>{{ $t("dashboard.warning") }}</h4>
      </div>
      <br>
      <br>
      <row container :gutter="10">
        <column :lg="4" :md="5" :xs="12" :lgOffset="2" :mdOffset="1">
          <div style="display: flex; justify-content: space-around;">
              <b-button
                  size="sm"
                  class="btn2"                
                  @click="rangeClick(180)"
                  :disabled="!user.subscription"
                  >180</b-button>
              <b-button
                  class="btn2"
                  size="sm"
                  @click="rangeClick(90)"
                  :disabled="!user.subscription"
                  >90</b-button>
            <b-button
                  class="btn2"
                  size="sm"
                  @click="rangeClick(60)"
                  :disabled="!user.subscription"
                  >60</b-button>
              <b-button
                  class="btn2"
                  size="sm"
                  @click="rangeClick(30)"
                  :disabled="!user.subscription"
                  >30</b-button>
              <b-button
                  class="btn2"
                  size="sm"
                  @click="rangeClick(15)"
                  :disabled="!user.subscription"
                  >15</b-button>
            <b-button
                  class="btn2"
                  size="sm"
                  @click="rangeClick(7)"
                  :disabled="!user.subscription"
                  >7</b-button>
          </div>
        </column>
        <column :lg="3" :md="5" :xs="12">
          <date-picker class="mx-datepicker-range"
            v-model="dateRange" range 
            clearable
            confirm
            confirm-text="OK"
            :disabled="!user.subscription"
            width="100%"
            input-class="form-control"
            >
          </date-picker>
        </column>
      </row>
      <br>
      <row container :gutter="10">
        <column :xs="12" :md="6" :lg="3">
          <div class="widget navy-bg h-100">
                <b-row>
                  <b-col>
                    <font-awesome-icon
                      icon="upload"
                      size="2x"
                      pull="left"
                    ></font-awesome-icon>
                  </b-col>
                  <b-col cols="9" align="end">
                    <span>{{ $t("dashboard.upload") }}</span>
                    <h2 class="font-bold">
                      <img
                        id="admin"
                        v-if="user.role === 'ROLE_ADMIN'"
                        src="./../../assets/icons8-admin-settings-male-64.png"
                        height="28"
                        style="filter: invert(100%)"
                      />
                      <b-tooltip target="admin" 
                        variant="light"                      
                        >&nbsp;&nbsp;{{ $t("dashboard.tooltipAdmin") }}&nbsp;&nbsp;
                      </b-tooltip>
                      <img
                        id="artist"
                        v-if="myArtistInfo"
                        src="./../../assets/icons8-rockstar-64.png"
                        height="28"
                        style="filter: invert(100%)"
                      />
                      <b-tooltip target="artist"
                        variant="light"
                        >&nbsp;&nbsp;{{ $t("dashboard.tooltipArtist") }}&nbsp;&nbsp;
                      </b-tooltip>
                      <img
                        id="subscription"
                        v-if="user.subscription"
                        src="./../../assets/icons8-sign-up-64.png"
                        height="28"
                        style="filter: invert(100%)"
                      />
                      <b-tooltip target="subscription"
                        variant="light"
                        >&nbsp;&nbsp;{{ $t("dashboard.tooltipSubscribed") }}&nbsp;&nbsp;
                      </b-tooltip>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      {{ metrics.uploads }}
                    </h2>
                  </b-col>
                </b-row>
          </div>
        </column>
          <column :xs="12" :md="6" :lg="3">
            <div class="widget navy-bg h-100">
                <b-row>
                  <b-col>
                    <font-awesome-icon
                      icon="calendar"
                      size="2x"
                      pull="left"
                    ></font-awesome-icon>
                  </b-col>
                  <b-col cols="8" align="end">
                    <span>{{ $t("dashboard.daysWithoutUpload") }}</span>
                    <h2
                      class="font-bold"
                      v-if="
                        metrics.lastDaysUpload !== 'El artista no tiene tracks'
                      "
                    >
                      {{ metrics.lastDaysUpload }}
                    </h2>
                    <h2
                      class="font-bold"
                      v-if="
                        metrics.lastDaysUpload === 'El artista no tiene tracks'
                      "
                    >
                      0
                    </h2>
                  </b-col>
                </b-row>
            </div>
          </column>
          <column :xs="12" :md="6" :lg="3">
            <div class="widget navy-bg h-100">
                <b-row>
                  <b-col>
                    <font-awesome-icon
                      icon="calculator"
                      size="2x"
                      pull="left"
                    ></font-awesome-icon>
                  </b-col>
                  <b-col cols="8" align="end">
                    <span>{{ $t("dashboard.avg") }}</span>
                    <h2 class="font-bold">
                      {{ computedAverage(this.metrics.monthlyAverageUpload) }}
                    </h2>
                  </b-col>
                </b-row>
            </div>
          </column>
          <column :xs="12" :md="6" :lg="3">
            <div class="widget navy-bg h-100">
                <b-row>
                  <b-col>
                    <font-awesome-icon
                      icon="heart"
                      size="2x"
                      pull="left"
                    ></font-awesome-icon>
                  </b-col>
                  <b-col cols="8" align="end">
                    <span>{{ $t("dashboard.followers") }}</span>
                    <h2 class="font-bold">{{ metrics.followers }}</h2>
                  </b-col>
                </b-row>
            </div>
          </column>
      </row>
      <br>
      <br>
      <row container :gutter="10">
        <column :xs="12" :md="12" :lg="12" style="text-align: center;">
          <h3>
            {{ $t("dashboard.reproductionsRanking") }}
          </h3>
        </column>
        <column :xs="12" :md="12" :lg="12">
          <div ref="chartdiv" id="chartdiv" style="width: 100%; height: 280px">
          </div>
        </column>
      </row>
      <row container :gutter="10" v-if="songRanking && songRanking.length !== 0">
        <column :xs="12" :md="12" :lg="12" style="text-align: center;">
          <h3>
            {{ $t("dashboard.songRanking") }}
          </h3>
        </column>
        <column :lg="8" :md="12" :xs="12" :lgOffset="2">
          <div>
            <b-table :items="songRanking" :fields="fields" class="tableClass">
              <template v-slot:cell(picture)="songRanking">
                <img class="img-fluid img-thumbnail" :src="computedImage(songRanking.item.picture)"
                  style="height: 40px; width: auto; object-fit: contain; object-position: center;"/>
                </template>
                  <template #head(title)="songRanking">
                    <div style="text-align: left;">
                      <div v-show="false">{{ songRanking.label }}</div>
                      {{ $t("dashboard.tableName") }}
                    </div>
                </template>
                  <template #head(artistName)="songRanking">
                    <div style="text-align: center;">
                      <div v-show="false">{{ songRanking.label }}</div>
                      {{ $t("dashboard.tableArtist") }}
                    </div>
                </template>
                <template #head(reproductions)="songRanking">
                  <div style="text-align: right;">
                    <div v-show="false">{{ songRanking.label }}</div>
                    {{ $t("dashboard.tableRepro") }}
                  </div>
                </template>
                <template #head(likes)="songRanking">
                  <div style="text-align: right;">
                    <div v-show="false">{{ songRanking.label }}</div>
                    {{ $t("dashboard.tableLikes") }}
                  </div>
                </template>

                <template #cell(title)="songRanking">
                    <h3>
                      {{ songRanking.item.title }}
                    </h3>
                </template>
                <template #cell(artistName)="songRanking">
                  <div class="artistColor" style="text-align: center;">
                    {{ songRanking.item.artistName }}
                  </div>
                </template>
                <template #cell(reproductions)="songRanking">
                  <div style="text-align: right;">
                    {{ songRanking.item.reproductions }}
                      &nbsp;&nbsp;
                      <font-awesome-icon
                                  icon="headphones"
                                  color="green">
                      </font-awesome-icon>
                  </div>
                </template>
                <template #cell(likes)="songRanking">
                  <div style="text-align: right;">
                    {{ songRanking.item.likes }}
                      &nbsp;&nbsp;
                      <font-awesome-icon
                                  icon="heart"
                                  color="red">
                      </font-awesome-icon>
                  </div>
                </template>
            </b-table>
          </div>
        </column>
      </row>
      <br>
    </div>  
  </div>
</template>

<script>
import consts from '@/consts'

import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themesDark from '@amcharts/amcharts4/themes/dark'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

am4core.useTheme(am4themesDark)
Vue.component('date-picker', DatePicker)

export default {
  name: 'dashboard',
  mounted () {
    am4core.ready(() => {
      let chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart)

      chart.paddingleft = 0
      chart.paddingRight = 40

      let data = []

      chart.data = data
      // let title = chart.titles.create()

      // title.text = 'Reproducciones por Período de Tiempo'
      // title.fontSize = 15

      let dateAxis = chart.xAxes.push(new am4charts.DateAxis())
      dateAxis.renderer.grid.template.location = 0

      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis())
      valueAxis.tooltip.disabled = true
      valueAxis.renderer.minWidth = 35
      // valueAxis.renderer.inside = true
      // valueAxis.title.text = 'Reproducciones'

      let series = chart.series.push(new am4charts.LineSeries())
      series.dataFields.dateX = 'timestamp'
      series.dataFields.valueY = 'reproductions'
      series.stroke = am4core.color('white')
      series.tooltipText = '{timestamp}: {reproductions}'
      series.tooltip.getFillFromObject = false
      series.tooltip.background.fill = am4core.color('#E6007E')

      chart.cursor = new am4charts.XYCursor()

      // Add scrollbar
      chart.scrollbarX = new am4core.Scrollbar()
      chart.scrollbarX.height = 10
      chart.scrollbarX.minHeight = 10
      chart.scrollbarX.startGrip.background.fill = am4core.color('#d3d3d3')
      chart.scrollbarX.endGrip.background.fill = am4core.color('#d3d3d3')
      chart.scrollbarX.thumb.background.fill = am4core.color('#d3d3d3')

      this.chart = chart
    })
  },

  beforeDestroy () {
    if (this.chart) {
      this.chart.dispose()
    }
  },

  data () {
    return {
      chart: null,
      dateFrom: '',
      dateTo: '',
      dateRange: '',
      dataChart: null,
      dia: 1000 * 60 * 60 * 24,
      /* table, definicion */
      fields: [
        {key: 'picture', label: ''},
        {key: 'title', sortable: true},
        {key: 'artistName', tdClass: 'artistColor'},
        {key: 'reproductions', sortable: true, sortDirection: 'desc'},
        {key: 'likes', sortable: true}
      ]
    }
  },

  components: {},

  watch: {
    /*
    al grafico se le cambia el array de datos mediante un objeto, agregamos un observador y un estado en el store, me avisa una vez que los datos estan disponibles
    */
    reproductionsRefresh: function (newQuestion, oldQuestion) {
      // this.chart.data = this.reproductions
      // while, array con set de datos con las reproducciones
      this.reproductions.forEach(element => {
        // find, busco en array generado con el rango completo seleccionado, generado en 0 con anterioridad
        const index = this.dataChart.findIndex(element2 => element2.timestamp === element.timestamp)
        if (index !== -1) {
          // assign, el valor de las reproducciones, ahora va a graficar bien, valores en 0, va a mostrar un 0
          this.dataChart[index].reproductions = element.reproductions
        }
      })

      this.chart.data = this.dataChart
    },
    /*
    como la info del artista es a demanda y no la carga a nivel de aplicacion
    agregamos un observador para cuando cargo la info del artista
    user_type = 0: FAN, user_type = 1: ARTIST, role: ROLE_USER o ROLE_ADMIN
    */
    myArtistInfoRefresh: function (newArtist, oldArtist) {
      // check, si usuario es artista
      const artistId = this.myArtistInfo === undefined ? null : this.myArtistInfo.id

      // assign, valores por defecto para dateRange dateFrom = hoy - 7 dias, dateTo = hoy
      const hoy = new Date()
      const semana = this.dia * 7
      const operacion = hoy.getTime() - semana
      const menosSemana = new Date(operacion)

      // this.dateFrom = menosSemana
      // this.dateTo = new Date()
      this.dateRange = [new Date(menosSemana), new Date()]

      // call
      this.getData(menosSemana, new Date(), artistId)
    },
    dateRange: function (newDateRange, oldDateRange) {
      const fromAux = new Date(newDateRange[0])
      const toAux = new Date(newDateRange[1])

      // check, si usuario es artista
      const artistId =
        this.myArtistInfo === undefined ? null : this.myArtistInfo.id

      // call
      this.getData(fromAux, toAux, artistId)
    }
  },

  created () {
    // get, informacion del artista
    this.getMyArtistInfo()
  },
  computed: {
    ...mapGetters('dashboard', [
      'metrics',
      'reproductions',
      'songRanking',
      'reproductionsRefresh'
    ]),
    ...mapGetters('user', ['user']),
    ...mapGetters('artist', ['myArtistInfo', 'myArtistInfoRefresh'])
  },
  methods: {
    ...mapActions('dashboard', [
      'getMetrics',
      'getReproductions',
      'getSongRanking'
    ]),
    ...mapActions('artist', ['getMyArtistInfo']),

    getImageUrl (item) {
      return item.value
    },

    computedAverage (value) {
      return typeof value !== 'undefined' ? value.toFixed(2) : 0
    },

    computedTime (value) {
      return typeof value !== 'undefined' ? (value / 60).toFixed(2) : 0
    },

    computedImage (value) {
      return consts.BASE_HOST + '/services' + value
    },

    rangeClick: function (value) {
      let cantidad = null
      let operacion = null
      let menosDias = null

      const hoy = new Date()

      switch (value) {
        case 7:
          cantidad = this.dia * 7
          operacion = hoy.getTime() - cantidad
          menosDias = new Date(operacion)
          this.dateFrom = menosDias
          break
        case 15:
          cantidad = this.dia * 15
          operacion = hoy.getTime() - cantidad
          menosDias = new Date(operacion)
          this.dateFrom = menosDias
          break
        case 30:
          cantidad = this.dia * 30
          operacion = hoy.getTime() - cantidad
          menosDias = new Date(operacion)
          this.dateFrom = menosDias
          break
        case 60:
          cantidad = this.dia * 60
          operacion = hoy.getTime() - cantidad
          menosDias = new Date(operacion)
          this.dateFrom = menosDias
          break
        case 90:
          cantidad = this.dia * 90
          operacion = hoy.getTime() - cantidad
          menosDias = new Date(operacion)
          this.dateFrom = menosDias
          break
        case 180:
          cantidad = this.dia * 180
          operacion = hoy.getTime() - cantidad
          menosDias = new Date(operacion)
          this.dateFrom = menosDias
          break
        default:
          break
      }

      // this.dateTo = hoy
      this.dateRange = [new Date(menosDias), hoy]

      // check, si usuario es artista
      const artistId =
        this.myArtistInfo === undefined ? null : this.myArtistInfo.id

      // call
      this.getData(menosDias, hoy, artistId)
    },

    getData: function (dateFrom, dateTo, artistId) {
      var aux1, aux2

      const param = {
        from: dateFrom.toISOString().substring(0, 10),
        to: dateTo.toISOString().substring(0, 10),
        artistId: artistId
      }

      // clear, generate de datos vacios para chart para el rango de fechas seleccionadao
      this.dataChart = []
      const diffInTime = dateTo.getTime() - dateFrom.getTime()
      const diffInDays = diffInTime / (1000 * 3600 * 24)

      // while, tantas veces, como diferencia entre rango seleccionada haya
      for (var i = 0; i <= diffInDays; i++) {
        aux1 = dateFrom.getTime() + (i * (1000 * 3600 * 24))
        aux2 = new Date(aux1)

        // add, una json para cada fecha seleccionada, para que no falte ninguna y el grafico funcione bien
        this.dataChart.push({
          reproductions: '0',
          timestamp: aux2.toISOString().substring(0, 10)
        })
      }

      // call, libreria vuex del store, populan estados
      this.getMetrics(param)
      this.getReproductions(param)
      this.getSongRanking(param)
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/variables.scss";

.dashboard-panel {
  overflow-y: scroll;
  height: $main-height;
  height: 84vh;
}

.p-lg {
  padding: 16px;
}

.video-thumbnail {
  position: relative;
  display: inline-block;
  cursor: pointer;
  margin: 10px;
}

/* date picker custom */
.form-control, .input {
  background-color: #393839 !important ;
  fill: #393839 !important ;
  padding: 10px 10px 10px 10px !important ;
  border: 1px solid #686868 !important ;
}
.btn {
  background-color: #393839 !important;
  color: #c0c0c0 !important;
}
.btn2 {
  background-color: #282828 !important;
  color: #c0c0c0 !important;
  cursor: pointer !important;
  width: 45px;
  height: 28px;  
}
.btn2:hover {
     border: 1px solid $accent-color;
}
.btn2:focus {
     background-color: $accent-color !important;
}
.dropdown-menu {
  color: #c0c0c0 !important;
  background-color: #393839 !important;
}
.btn-outline-primary {
  color: #393839 !important;
  border-color: #393839 !important;
}
.text-muted {
  background-color: #393839 !important;
  color: #c0c0c0 !important;
}
/* date picker custom */
.image1 {
  filter: invert(100%);
}
.container-fluid-song-ranking-track {
    //width: auto;
    height: 85px;
    display: flex;
    justify-content: start;
    flex-direction: row;
 }
 // datapicker
 .mx-datepicker-range {
    width: 100%;
}
.widget {
  padding-bottom: 0px;
}
.artistColor {
  color: $accent-color;
}
.tableClass {
  width: 100%;
  border-collapse: collapse;
}
.tooltipClass {
  padding: 5px !important;
  background-color: $secondary-color !important;
  color: $primary-color !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Dashboard.vue